import React, { useEffect, useState, Fragment } from 'react'
import { getWeatherForecast } from '../services/WeatherService'
import { Container, ListGroup, ListGroupItem, InputGroup, Form, Button, Card, Row, Col } from 'react-bootstrap'
import * as Icon from 'react-bootstrap-icons'
import { useDispatch, useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'
import Select from 'react-select'
import { GetInfo } from '../Redux/TareasV2Ducks'
import NomenclaturasB from '../components/WorkFlow/NomenclaturasB'
import { Typography } from '@mui/material'


const paginationOptions = {
    rowsPerPageText: 'Mostrar',
    rangeSeparatorText: 'de',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'Todos',
}

const FilterComponent = ({ onFilter, onClear, filterText }) => (
    <div className='w-100 pe-2 justify-content-left d-flex'>
        <InputGroup className='w-75'>
            <Form.Control
                placeholder="Filtrar Nomenclaturas Disponibles"
                aria-label="Filtrar Nomenclaturas Disponibles"
                value={filterText}
                onChange={onFilter}
            />
            <Button variant="outline-secondary" onClick={onClear}>
                <Icon.Trash2Fill />
            </Button>
        </InputGroup>
    </div>
)


const WorkFlowPage = ({ causa, onclickWorkflowValidado, setShow }) => {
    const dispatch = useDispatch()

    const { register: registerC, handleSubmit: handleSubmitC, reset: resetC } = useForm()

    const getInfo = useSelector((store) => store.tareasV2.getInfo)
    const gruposServicios = useSelector((store) => store.tareasV2.gruposServicios)
    const listaAcciones = useSelector((store) => store.tareasV2.listaAcciones)
    const listSubTask = useSelector((store) => store.tareasV2.listSubTask)


    const [resetPaginationToggle, setResetPaginationToggle] = useState(false)
    const [filterText, setFilterText] = useState('')
    const [grupoDefault, setGrupoDefault] = useState(null)
    const [servicioDefault, setServicioDefault] = useState(null)
    const [offService, setOffService] = useState(false)


    const [FilterUseDocsTotal, setFilterUseDocsTotal] = useState([])


    const subHeaderComponentMemo = React.useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle)
                setFilterText('')
            }
        }

        return (<FilterComponent onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} />)
    }, [filterText, resetPaginationToggle])

    const columnasTotal = [
        { name: "Nomenclaturas Disponibles", cell: (row) => row.nomenclatura, selector: row => row.nomenclatura, sortable: false },
        {
            name: "", cell: (row) => <Button /*onClick={(e)=>openClientDetail(row.nomenclatura)}*/ size="sm" variant='outline-info'><Icon.CaretRightFill /></Button>,
            ignoreRowClick: false,
            button: true
        },
    ]

    const [searchGrupos, setSearchGrupos] = useState(true)
    const [searchServicio, setSearchServicio] = useState(false)
    const [searchDisableServicio, setSearchDisableServicio] = useState(true)

    const [grupo, setGrupo] = useState([])
    const [servicio, setServicio] = useState([])

    const [nombreGrupo, setNombreGrupo] = useState('Seleccione Grupo');
    const [nombreServicio, setNombreServicio] = useState('Seleccione Servicio')
    const [nomenclaturasDisponibles, setNomenclaturasDisponibles] = useState([])
    const [taskTemplateId, setTaskTemplateId] = useState(null)
    const [taskWorkflowId, setTaskWorkflowId] = useState(null)
    const [dateChange, setDateChange] = useState(null)
    const [dateauxnom, setDateauxnom] = useState(null)




    const [idGrupo, setIdGrupo] = useState(null);
    const [idServicio, setIdServicio] = useState(null)
    //const [_gruposServicios,_SetGruposServicios]= useState([])
    //const [nomenclaturasDisponibles, setNomenclaturasDisponibles] = useState([])




    useEffect(() => {
    }, [getInfo])
    /*useEffect(() => {
        if (gruposServicios.length > 0)  _SetGruposServicios(gruposServicios)
    }, [gruposServicios])*/


    useEffect(() => {
        //pppppppppppppppppppppppp
        if (gruposServicios.length > 0) {
            if (causa?.legalGroupId) setIdGrupo(causa.legalGroupId)
            if (causa?.cosmosId) setTaskWorkflowId(causa.cosmosId)

            setSearchGrupos(false)
            const grupoAux = gruposServicios.map((item) => { return { value: item.group.id, label: item.group.description } })
            setGrupo(grupoAux)

            if (causa?.legalGroupId && causa?.legalServiceId) {

                let auxGroup = grupoAux.find(item => item.value == causa.legalGroupId)

                setGrupoDefault(auxGroup)
                onSearchService(auxGroup)

                const servicios = gruposServicios.find(item => item.group.id == causa.legalGroupId).services;

                let auxService = servicios.map((item) => { return { value: item.service.id, label: item.service.name } })
                auxService = auxService.find(item => item.value == causa.legalServiceId)

                setServicioDefault(auxService)

                onSearchNomenclatura(auxService)
            }

        }
        else setSearchGrupos(true)
    }, [gruposServicios])

    useEffect(() => {
    }, [listaAcciones])
    useEffect(() => {
    }, [listSubTask])

    useEffect(() => { dispatch(GetInfo()) }, [])

    const onSearchService = (event) => {
        if (event == null) {
            setOffService(false)
            setServicioDefault(null)
            setSearchServicio(false)
            setGrupoDefault(null)
            setNombreGrupo('Seleccione Grupo')
            setIdGrupo(null)
            setNombreServicio('Seleccione Servicio')
            setIdServicio(null)
            setServicio([])
            setSearchServicio(false)
            setSearchDisableServicio(false)
            setNomenclaturasDisponibles([])
            setDateauxnom(new Date())

            return;
        }
        setOffService(true)
        setServicioDefault(null)
        setSearchServicio(true)
        setGrupoDefault(event)
        setNombreGrupo(event.label)
        setIdGrupo(event.value)
        setNombreServicio('Seleccione Servicio')
        setIdServicio(null)
        const servicios = gruposServicios.find(item => item.group.id == event.value).services
        setServicio(servicios.map((item) => { return { value: item.service.id, label: item.service.name } }))
        setSearchServicio(false)
        setSearchDisableServicio(false)
        setNomenclaturasDisponibles([])
        setDateauxnom(new Date())
    }

    const onSearchNomenclatura = (event) => {
        if (event == null) {
            setOffService(false)
            setNombreServicio(null)
            setIdServicio(null)
            setServicioDefault(null)
            setNomenclaturasDisponibles([])
            setDateauxnom(new Date())
            setFilterUseDocsTotal([])
            setDateChange(new Date())
            setTaskTemplateId(null)

            return;
        }

        var auxIdGrupo = idGrupo
        if (auxIdGrupo == null)
            auxIdGrupo = causa?.legalGroupId

        setOffService(true)
        setNombreServicio(event.label)
        setIdServicio(event.value)
        setServicioDefault(event)
        const Listnomenclatures = gruposServicios.find(item => item.group.id == auxIdGrupo).nomenclaturas
        setNomenclaturasDisponibles(Listnomenclatures)
        setDateauxnom(new Date())
        const FilterUseDocsTotalB = Listnomenclatures.filter(item => {
            return filterText ? item.nomenclatura && item.nomenclatura.toLowerCase().includes(filterText.toLowerCase()) : true
        })
        setFilterUseDocsTotal(FilterUseDocsTotalB)
        if (causa?.cosmosId) {
            setTaskTemplateId(causa.cosmosId)
        } else {
            const servicios = gruposServicios.find(item => item.group.id == auxIdGrupo).services
            setDateChange(new Date())
            var sss = servicios.find(item => item.service.id == event.value).taskTemplateId
            setTaskTemplateId(sss)
        }
    }

    const onclickWorkflowCreado = (workflow) => {
        // AQUI LLEGA EL WORKFLOW CREADO O ACTUALIZADO Y SE ENVIA A LA VALIDACION

        //////////////////////////////////////////

        setResetPaginationToggle(false)
        setFilterText('')
        setGrupoDefault(null)
        setServicioDefault(null)
        setFilterUseDocsTotal([])
        setSearchGrupos(true)
        setSearchServicio(false)
        setSearchDisableServicio(true)
        setGrupo([])
        setServicio([])
        setNombreGrupo('Seleccione Grupo');
        setNombreServicio('Seleccione Servicio')
        setNomenclaturasDisponibles([])
        setTaskTemplateId(null)
        setTaskWorkflowId(null)
        setDateChange(null)
        setIdGrupo(null)
        setIdServicio(null)
        setDateauxnom(new Date())

        onclickWorkflowValidado(workflow, causa)

        //////////////////////////////////////////
    }

    return (
        <div className="container-fluid m-3">
            <Typography variant="h6" sx={{ mb: 4 }}>Asignacion de Tarea <Typography variant="h5" sx={{ mb: 4 }}> {nombreGrupo} / {nombreServicio} </Typography></Typography>
            <Row>
                <Col>
                    <div className='mb-2'>Seleccione Grupo</div>
                    <Select
                        onChange={(e) => onSearchService(e)}
                        options={grupo}
                        className="basic-single mb-4"
                        classNamePrefix="select"
                        //defaultValue={colourOptions[0]}
                        isDisabled={false}
                        isLoading={searchGrupos}
                        isClearable={true}
                        isRtl={false}
                        isSearchable={true}
                        name="color"
                        value={grupoDefault}
                    />
                </Col>
                <Col>
                    <div className='mb-2'>Seleccione Servicio</div>
                    <Select
                        onChange={(e) => onSearchNomenclatura(e)}
                        options={servicio}
                        className="basic-single mb-4"
                        classNamePrefix="select"
                        //defaultValue={colourOptions[0]}
                        isDisabled={searchDisableServicio}
                        isLoading={searchServicio}
                        isClearable={true}
                        isRtl={false}
                        isSearchable={true}
                        value={servicioDefault}
                    //name="color"
                    />
                </Col>
            </Row>
            <NomenclaturasB setShowModal={setShow} onclickWorkflowCreado={onclickWorkflowCreado} dateChange={dateChange} dateauxnom={dateauxnom} nomenclaturasDisponibles={nomenclaturasDisponibles} listSubTask={listSubTask} taskTemplateId={taskTemplateId} taskWorkflowId={taskWorkflowId} idGrupo={idGrupo} idServicio={idServicio} nombreGrupo={nombreGrupo} nombreServicio={nombreServicio} servicios={servicio} offService={offService} />
        </div>
    );
}

export default WorkFlowPage
